import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../../actions/standardActions';

// api
import postedOffersApi from '../../sources/api/postedOffersApi';

// constants
import { POST_NEW_TRADE_OFFER } from '../../constants/postedOffersTypes';
import { POST_NEW_TRADE_OFFER_SUCCESS, POST_NEW_TRADE_OFFER_ERROR, POST_NEW_TRADE_OFFER_NOT_AUTH } from '../../constants/messages';

// lib
import httpSaga from '../../lib/httpSaga';
import { toastr } from 'react-redux-toastr';
import { push } from 'react-router-redux';

export function* postNewTradeOffer(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const params = action.payload;

  try {
    yield* httpSaga(POST_NEW_TRADE_OFFER, call(postedOffersApi.postNewOffer, params));
    yield toastr.success('success', POST_NEW_TRADE_OFFER_SUCCESS);
    yield put(push('/reps/trade-post'));
  } catch (e) {
    if (e.response) {
      if (e.response.statusCode === 403) {
        yield toastr.error(POST_NEW_TRADE_OFFER_NOT_AUTH);
      } else {
        yield toastr.error(e.response.body.message);
      }
    } else {
      yield toastr.error(POST_NEW_TRADE_OFFER_ERROR);
    }
    yield put(error(POST_NEW_TRADE_OFFER, e));
  } finally {
    yield put(doneIndicator(POST_NEW_TRADE_OFFER));
  }
}

export function* watchPostNewTradeOffer() {
  yield takeEvery(POST_NEW_TRADE_OFFER, postNewTradeOffer);
}

export default function* root() {
  yield all([
    fork(watchPostNewTradeOffer)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/postedOffers/postNewTradeOffer.js